import { styled } from '../../../core/theme/styled';

export const QrCodeContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
`;
